import React from 'react';
import '../utils/benefits.css';
import BenefitsImageSlider from './BenefitsImageSlider';

export default function Benefits() {
    return (

        <div className="container benefits-section">
            <div className="row">
                <div className="container">
                    <div className="row content-wrap as-content-wrap flex-lg-nowrap justify-content-between position-relative gx-0 gx-lg-4">

                        {/* Text Content (Order 2 on Desktop, Order 1 on Mobile) */}
                        <div className="col-lg-6 mt-4 mt-lg-0 d-flex flex-column py-lg-5 justify-content-start order-lg-1 order-2">
                            {/* Title Block */}
                            <div className="row row-cols-1 mb-4">
                                <div className="col">
                                    <h4 className="mb-3 c-c00 f-uc">Less is more.</h4>
                                    <p className="mb-0">Go further with your budget by reducing costs typical of traditional photoshoots. Add variety to your photos <b>without changing the product</b>. At the baseline, here's what to expect:</p>
                                </div>
                            </div>

                            {/* Content Blocks Grid */}
                            <div className="d-grid gap-2">
                                <div className="row row-cols-2 row-cols-lg-3 g-2">
                                    <div className="col">
                                        <div className="benefit-heading p-3 border rounded text-left h-100 d-flex flex-column">
                                            <h3 className="mb-2 f-a fs-2">60%+</h3>
                                            <p className="mb-0 fs-6">Reduced Production Cost</p>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="benefit-heading p-3 border rounded text-left h-100 d-flex flex-column">
                                            <h3 className="mb-2 f-a fs-2">40%</h3>
                                            <p className="mb-0 fs-6">Faster Photoshoots</p>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="benefit-heading p-3 border rounded text-left h-100 d-flex flex-column">
                                            <h3 className="mb-2 f-a fs-2">2x</h3>
                                            <p className="mb-0 fs-6">Increased Content</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="row row-cols-2 row-cols-lg-3 g-2">
                                    <div className="col">
                                        <div className="p-3 border rounded text-left h-100 d-flex flex-column justify-content-left">
                                            <p className="mb-0 fs-6">Reduce model hourly fees.</p>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="p-3 border rounded text-left h-100 d-flex flex-column justify-content-left">
                                            <p className="mb-0 fs-6">Eliminate Hair & Makeup expenses</p>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="p-3 border rounded text-left h-100 d-flex flex-column justify-content-left">
                                            <p className="mb-0 fs-6">Reduce time spent on photoshoots</p>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="p-3 border rounded text-left h-100 d-flex flex-column justify-content-left">
                                            <p className="mb-0 fs-6">Remove content license limits</p>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="p-3 border rounded text-left h-100 d-flex flex-column justify-content-left">
                                            <p className="mb-0 fs-6">Increase content variety across platforms</p>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="p-3 border rounded text-left h-100 d-flex flex-column justify-content-left">
                                            <p className="mb-0 fs-6">Increase and optimize conversions</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Image Column (Order 1 on Desktop, Order 2 on Mobile) */}
                        <div className="col-lg-6 d-flex order-lg-2 order-1">
                            <BenefitsImageSlider />
                        </div>

                    </div>
                </div>
            </div>
        </div>

    );
}